module.exports = __webpack_public_path__ + "images/d7c45e613484f574df148cf568a413ec-dial_question.png";